import CustomInput from 'components/Form/TextField/TextField.cmp';
import React, { useEffect, useState, useRef } from 'react';
import { useSearchQuery } from 'components/AllDialogs/templates/templatesSearch/hooks/useSearchQuery';
import SearchIcon from '@mui/icons-material/Search';

interface SearchInputProps {
  onSearchChange?: (value: string) => void;
}

const SearchInput = ({ onSearchChange }: SearchInputProps) => {
  const [value, setValue] = useState('');
  const { searchQuery } = useSearchQuery(value);
  const timeoutId = useRef<any>(null);

  useEffect(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      searchQuery.refetch();
      onSearchChange?.(value);
    }, 500); // delay in milliseconds

    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [value, onSearchChange]);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <CustomInput
      suppressErrorSpace={true}
      grayInput={true}
      fieldProps={{
        autoFocus: true,
        placeholder: 'Search Template',
        startAdornment: <SearchIcon />,
        onChange: onChange,
        value: value,
      }}
    />
  );
};

export default SearchInput;
